"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendMessageDataValidator = exports.GetLastSelectedDataValidator = exports.DeleteOwnAuthUserDataValidator = exports.UpdateRoundDataValidator = exports.UpdateUserDataValidator = exports.SubmitFeedbackDataValidator = exports.AddPeersToRoundDataValidator = exports.FN_REGION = void 0;
const util_1 = require("./util");
exports.FN_REGION = 'europe-west3';
exports.AddPeersToRoundDataValidator = util_1.generateValidator('AddPeersToRoundData');
exports.SubmitFeedbackDataValidator = util_1.generateValidator('SubmitFeedbackData');
exports.UpdateUserDataValidator = util_1.generateValidator('UpdateUserData');
exports.UpdateRoundDataValidator = util_1.generateValidator('UpdateRoundData');
exports.DeleteOwnAuthUserDataValidator = util_1.generateValidator('DeleteOwnAuthUserData');
exports.GetLastSelectedDataValidator = util_1.generateValidator('GetLastSelectedData');
exports.SendMessageDataValidator = util_1.generateValidator('SendMessageData');
//# sourceMappingURL=functions.js.map